import { wagmiConfig as config, } from "@wagmiconfig";
import { getAccount, } from "wagmi/actions";
import type { CheckinResponse, } from "../types";


export const checkin = async ( wallet: string ): Promise<CheckinResponse|false> => {
	const { address, } = getAccount(config);
	if(address) {
		const response = await fetch(`/api/ident/checkin?wallet=${wallet}`);
		if(!response.ok) {
			throw new Error(`HTTP error! status: ${response.status}`);
		}
		const result = (await response.json()) as CheckinResponse;
		if(result) {
			return result;
		}
	}
	return false;
}
